import {
    ALLOWED_RASTER_EXTENSIONS,
    ALLOWED_RASTER_MIME_TYPES,
    ALLOWED_SVG_EXTENSIONS,
    ALLOWED_SVG_MIME_TYPES,
    MAX_IMAGE_FILE_BYTES,
} from "./image-constants";

export function formatFileSize(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

export function isRemoteImageUrl(value) {
    return typeof value === "string" && /^https?:\/\//i.test(value);
}

export function readFileAsText(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result ?? ""));
        reader.onerror = () => reject(reader.error ?? new Error("Failed to read file"));
        reader.readAsText(file);
    });
}

export function validateFileSize(file, maxBytes = MAX_IMAGE_FILE_BYTES) {
    if (!file) return { valid: false, key: "alert_imagen_excede_tamano" };
    if (file.size > maxBytes) return { valid: false, key: "alert_imagen_excede_tamano" };
    return { valid: true };
}

function matchesExtension(fileName, extensions) {
    const lower = String(fileName ?? "").toLowerCase();
    return extensions.some((ext) => lower.endsWith(ext));
}

export function validateRasterImageFile(file) {
    const sizeCheck = validateFileSize(file);
    if (!sizeCheck.valid) return sizeCheck;

    const mimeOk = ALLOWED_RASTER_MIME_TYPES.includes(file.type);
    const extOk = matchesExtension(file.name, ALLOWED_RASTER_EXTENSIONS);
    if (!mimeOk && !extOk) {
        return { valid: false, key: "alert_imagen_formato_invalido" };
    }
    return { valid: true };
}

export function validateSvgFile(file) {
    const sizeCheck = validateFileSize(file);
    if (!sizeCheck.valid) return sizeCheck;

    const mimeOk = ALLOWED_SVG_MIME_TYPES.includes(file.type);
    const extOk = matchesExtension(file.name, ALLOWED_SVG_EXTENSIONS);
    if (!mimeOk && !extOk) {
        return { valid: false, key: "alert_svg_formato_invalido" };
    }
    return { valid: true };
}

export function isSvgMarkup(value) {
    return typeof value === "string" && value.trim().startsWith("<svg");
}

export function buildFileUploadPayload(file, dataUrl) {
    const match = String(dataUrl).match(/^data:([^;]+);base64,(.+)$/);
    const fileType = match?.[1] ?? file?.type ?? "image/jpeg";
    const base64 = match?.[2] ?? String(dataUrl);
    const extension = fileType === "image/png" ? "png" : "jpg";
    const fileName = file?.name || `image.${extension}`;

    return { base64, fileType, fileName };
}
